/* eslint-disable no-console */
import React, { useContext } from 'react';
import { makeStyles } from '@rentacenter/racstrap';

import { RouteComponentProps } from 'react-router-dom';

import { appConfig } from '../../config/app-config';
import { MicroFrontend } from './MicroFrontEnd';
import { ContainerContext } from '../../app/authenticated/Authenticated';

export const testId = 'inventoryTestId';
const useStyles = makeStyles(() => ({
  microAppContainer: {
    marginTop: '3rem',
  },
}));
// Agreement
export const Inventory = ({ history }: RouteComponentProps) => {
  const containerData = useContext(ContainerContext);
  console.log('Inside the Inventory MFE componenet', history);
  const classes = useStyles();
  return (
    <div className={classes.microAppContainer} data-testid={testId}>
      <MicroFrontend
        config={appConfig.microfrontends.inventory}
        history={history}
        customProps={containerData}
      />
    </div>
  );
};
